<template>
  <span v-editable="blok">
    <b-nav-item
      v-if="blok.link.linktype=='url'"
      @click="track()"
      :href="blok.link.cached_url | formatSbInternalLink"
    >
      <span :class="classes">{{ blok.label }}</span>
    </b-nav-item>
    <b-nav-item v-else @click="track()" :to="blok.link.cached_url | formatSbInternalLink">
      <span :class="classes">{{ blok.label }}</span>
    </b-nav-item>
  </span>
</template>
<script>
export default {
  name: "navigation-item",
  props: {
    blok: Object
  },
  methods: {
    track: function() {
      try {
        gtag('event', 'nav_click', {
          'event_label': this.$props.blok._uid
        });
      } catch(e) {
        console.warn(e);
      }
    }
  },
  computed: {
    classes: function() {
      return [
        this.$props.blok.classes
      ].join(' ')
    }
  }
}
</script>
